import { gql, DocumentNode } from "@apollo/client";

export const UPDATE_DOC_VISIBILITY_QUERY: DocumentNode = gql`
  query UpdateDocVisibility($docId: Int!, $visibility: Boolean!) {
    updateDocVisibility(docId: $docId, visibility: $visibility)
  }
`;

export const ADMIN_CUSTOMER_PASSWORD_RESET_QUERY: DocumentNode = gql`
  query AdminCustomerPasswordReset($email: String!, $source: String!) {
    adminCustomerPasswordReset(email: $email, source: $source)
  }
`;

export const GET_ADMIN_USERS: DocumentNode = gql`
  query GetAdminUsers($limit: Int!, $offset: Int!) {
    adminUsers(limit: $limit, offset: $offset) {
      id
      email
      firstName
      lastName
      phone
      Status
      role
      permissions {
        name
        permission
        subSections {
          name
          permission
        }
      }
    }
  }
`;

export const UNIQUE_ROLES = gql`
  query UniqueRoles {
    uniqueRoles {
      roles
    }
  }
`;

export const LOGIN_ADMIN_USER: DocumentNode = gql`
  query LoginAdminUser($email: String!, $password: String!) {
    adminLogin(input: { email: $email, password: $password }) {
      token
    }
  }
`;

export const GET_ACCESS = gql`
  query getAccess {
    getAccess {
      name
      permission
      subSections {
        name
        permission
      }
    }
  }
`;

export const PREVIEW_ESTIMATE = gql`
  query PreviewEstimate($projectId: Int!) {
    previewEstimate(projectId: $projectId) {
      url
      signed
    }
  }
`;

export const RESET_PASSWORD_QUERY = gql`
  query resetPasswordAdmin($email: String!) {
    resetPasswordAdmin(email: $email)
  }
`;

export const GET_ADMIN_USER_BY_ID = gql`
  query GetAdminUserById($id: Int!) {
    adminUser(id: $id) {
      id
      firstName
      lastName
      email
      phone
    }
  }
`;

export const GET_UPLOAD_URL = gql`
  query GetUploadUrl {
    getUploadUrl {
      url
    }
  }
`;

export const COC_IMAGES = gql`
  query CocImages($projectId: Int!) {
    cocImages(projectId: $projectId) {
      sections {
        type
        img {
          fileId
          url
        }
      }
    }
  }
`;

export const GET_PROJECTS = gql`
  query GetProjects(
    $limit: Int!
    $offset: Int!
    $id: Int
    $status: ProgressStatus
    $reason: ArchiveReason
    $completed: Boolean
  ) {
    projects(
      limit: $limit
      offset: $offset
      id: $id
      status: $status
      reason: $reason
      completed: $completed
    ) {
      id
      customerId
      projectRefNumber
      MeasurementSupportRequested
      customer {
        id
        firstName
        lastName
        email
        phone
        address {
          id
          street
          zipCode
          city
          state
        }
      }
      progress {
        id
        projectId
        approved
        remarks
        title
        description
        completed
        step
      }
      products {
        id
        name
        thumbnail
        duration
        priority
      }
      files {
        url
        type
        id
        projectId
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      paymentType
      orderStatus {
        productSystemId
        componentType
        orderSent
        orderConfirmed
      }
    }
  }
`;

export const GET_PROJECT_BY_ID = gql`
  query GetProjectById($id: Int!) {
    project(id: $id) {
      id
      customerId
      customer {
        id
        email
        phone
        firstName
        lastName
        verified
        createdAt
        updatedAt
        leads {
          id
          roofCondition
          dateOfDamage
          typeOfDamaged
        }
        address {
          id
          userId
          street
          zipCode
          city
          state
          lat
          lng
        }
        projectId
      }
      progress {
        id
        projectId
        approved
        remarks
        title
        description
        completed
        step
      }
      products {
        id
        name
        thumbnail
        duration
        priority
      }
      files {
        url
        type
        id
        projectId
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      paymentType
    }
  }
`;

export const GET_LEADS = gql`
  query GetLeads($limit: Int!, $offset: Int!, $refId: Int) {
    leads(limit: $limit, offset: $offset, refId: $refId) {
      id
      uuid
      streetAddress
      unit
      zipCode
      city
      state
      roofCondition
      dateOfDamage
      typeOfDamaged
      firstName
      lastName
      phone
      email
      utm
      refId
      customerReferralName
      createdAt
      updatedAt
    }
  }
`;

export const GET_LEAD_BY_ID = gql`
  query GetLeadById($id: Int!) {
    lead(id: $id) {
      id
      uuid
      streetAddress
      unit
      zipCode
      city
      state
      roofCondition
      dateOfDamage
      typeOfDamaged
      firstName
      lastName
      phone
      email
      utm
      refId
      customerReferralName
      createdAt
      updatedAt
    }
  }
`;

export const GET_WAIT_LIST = gql`
  query GetWaitLists($limit: Int!, $offset: Int!) {
    waitList(limit: $limit, offset: $offset) {
      id
      uuid
      streetAddress
      unit
      zipCode
      city
      state
      roofCondition
      dateOfDamage
      typeOfDamaged
      firstName
      lastName
      phone
      email
      utm
      refId
      customerReferralName
      createdAt
      updatedAt
    }
  }
`;

export const GET_INSURANCE_COMPANIES = gql`
  query GetInsuranceCompanies($limit: Int!, $offset: Int!) {
    insuranceCompanies(limit: $limit, offset: $offset) {
      id
      companyName
      companyLogo
      claimLink
      createdAt
      updatedAt
    }
  }
`;

export const GET_INSURANCE_COMPANY_BY_ID = gql`
  query GetInsuranceCompanyById($id: Int!) {
    insuranceCompany(id: $id) {
      id
      companyName
      companyLogo
      claimLink
      createdAt
      updatedAt
    }
  }
`;

export const GET_CUSTOMERS = gql`
  query GetCustomers($limit: Int!, $offset: Int!) {
    customers(limit: $limit, offset: $offset) {
      id
      email
      password
      phone
      firstName
      lastName
      resetCode
      expiry
      verified
      createdAt
      updatedAt
      leads {
        id
        uuid
        streetAddress
        unit
        zipCode
        city
        state
        roofCondition
        dateOfDamage
        typeOfDamaged
        firstName
        lastName
        phone
        email
        utm
        refId
        customerReferralName
        createdAt
        updatedAt
      }
      address {
        id
        userId
        street
        zipCode
        city
        state
        lat
        lng
      }
      projectId
    }
  }
`;

export const GET_CUSTOMER_BY_ID = gql`
  query GetCustomerById($id: Int!) {
    customer(id: $id) {
      id
      email
      phone
      firstName
      lastName
      verified
      createdAt
      updatedAt
      leads {
        id
        uuid
      }
      address {
        id
        userId
        street
        zipCode
        city
        state
        lat
        lng
      }
      projectId
    }
  }
`;

export const GET_INVOICES = gql`
  query GetInvoices($projectId: Int!) {
    invoices(projectId: $projectId) {
      projectId
      total {
        projectSubTotal
        glasFee
        projectTotal
        priorPayments
        paymentDue
      }
      invoices {
        productId
        name
        invoiceType
        Items {
          id
          projectId
          productId
          invoiceType
          name
          description
          identifier
          amount
          date
          url
        }
        total {
          invoiceTotal
          estimateTotal
          paymentDue
          refundDue
        }
      }
      addOns {
        productId
        name
        invoiceType
        Items {
          id
          projectId
          productId
          invoiceType
          name
          description
          identifier
          amount
          date
          url
        }
        total {
          invoiceTotal
          estimateTotal
          paymentDue
          refundDue
        }
      }
    }
  }
`;

export const GET_PROJECT_DETAILS = gql`
  query ProjectDetails($projectId: Int!) {
    projectDetails(projectId: $projectId) {
      projectId
      ProjectAddress {
        id
        userId
        street
        zipCode
        city
        state
        lat
        lng
      }
      productSystem {
        id
        name
        isMaterialSelectionRequired
        isLaborSelectionRequired
        laborMeasurements {
          id
          name
          unit
          value {
            materialId
            quantity
          }
        }
      }
      customerDetails {
        id
        email
        phone
        firstName
        lastName
        verified
        createdAt
        updatedAt
        addedBy
        emailAddedBy
        address {
          id
          street
          city
          zipCode
          state
        }
      }
      insuranceScope {
        id
        projectId
        approved
        materialMeasurements {
          isSelected
          productId
          name
          orderSent
          orderConfirmed
          jobStartDate
          supplierName
          supplierId
          measurements {
            id
            unit
            name
            customerDisplayName
            forceCustomerSelection
            parents {
              id
            }
            associatedMaterials {
              id
              name
              measurementId
              brand
              description
              price
              UnitPrice
              quality
              measurementUnit
              coverageAmount
              isSelected
              images {
                id
                url
                type
                createdAt
                updatedAt
              }
              variants {
                id
                color
                images {
                  id
                  url
                  type
                  createdAt
                  updatedAt
                }
                isSelected
              }
              tags {
                Id
                tagName
              }
            }
            value {
              materialId
              quantity
              unitsNeeded
            }
            categoryId
            createdAt
            updatedAt
          }
        }
        laborMeasurements {
          name
          productId
          isSelected
          orderSent
          orderConfirmed
          installationDate
          removalDate
          measurements {
            measurementId
            id
            name
            unit
            parents {
              id
            }
            value {
              materialId
              quantity
            }
            associatedContractor {
              id
              name
              website
              description
              isSelected
              total
              associatedLabor {
                id
                description
                price
                measurementUnit
                coverageAmount
                isSelected
                variants {
                  id
                  productSystemId
                  price
                  description
                  measurementUnit
                  coverageAmount
                  createdAt
                  updatedAt
                  isSelected
                }
                createdAt
                updatedAt
              }
              files {
                id
                name
                description
                url
                fileType
                createdAt
                updatedAt
              }
              trades {
                id 
                name
                description
                yearsOfDoing
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        paymentDetails {
          id
          projectId
          step
          approved
          title
          description
          remarks
          amount
          paymentLog
          transactionId
          pgStatus
          completed
          paymentType
          email
          createdAt
          updatedAt
          payThrough
        }
        insuranceClaim {
          id
          projectId
          providerId
          companyName
          Insurer
          ClaimNumber
          ClaimDate
          TotalPayout
          FirstCheck
          SecondCheck
          Approved
          inspectionTime
        }
        addOns {
          id
          projectId
          addonName
          description
          price
          createdAt
          updatedAt
        }
      }
      installationDetails {
        id
        projectId
        installationDate
        fromDate
        toDate
        remarks
      }
      paymentDetails {
        id
        projectId
        step
        approved
        title
        description
        remarks
        amount
        paymentLog
        transactionId
        pgStatus
        completed
        paymentType
        email
        createdAt
        updatedAt
        Images
        payThrough
      }
      documents {
        id
        projectId
        url
        unsignedUrl
        type
        createdAt
        updatedAt
        fileName
        archived
        dateOfLoss
        dateOfScope
        customerVisibility
      }
      cocAndInvoice {
        id
        projectId
        url
        type
        createdAt
        updatedAt
      }
      progress {
        id
        step
        projectId
        title
        description
        remarks
        approved
        completed
        payment {
          id
          name
          paymentType
          percent
          amount
          stepNumber
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      preferredQuality
      Archived
      MeasurementSupportRequested
      MeasurementRemarks
      PaymentType
      ProjectRoles {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

export const GET_MATERIALS_BY_CATEGORY = gql`
  query MaterialsByCategory($id: Int!) {
    materialsByCategory(id: $id) {
      id
      name
      measurement {
        id
        name
        unit
        parents {
          id
        }
        categoryId
        createdAt
        updatedAt
      }
      brand
      description
      price
      quality
      measurementUnit
      coverageAmount
      images {
        id
        url
        type
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_MATERIAL_MEASUREMENTS_FOR_PROJECT = gql`
  query materialMeasurements($limit: Int!, $offset: Int!) {
    materialMeasurements(limit: $limit, offset: $offset) {
      id
      name
      unit
      parents {
        id
        name
      }
      categoryId
    }
  }
`;

export const GET_LABOR_MEASUREMENTS_FOR_PROJECT = gql`
  query laborMeasurements($limit: Int!, $offset: Int!) {
    laborMeasurements(limit: $limit, offset: $offset) {
      id
      name
      unit
      parents {
        id
        name
      }
    }
  }
`;

export const GET_PROJECT_PRODUCTS = gql`
  query project($id: Int!) {
    project(id: $id) {
      id
      products {
        id
        name
      }
      paymentType
      insuranceClaim {
        id
        providerId
        companyName
        Insurer
        ClaimNumber
        ClaimDate
        TotalPayout
        FirstCheck
        SecondCheck
        Approved
      }
    }
  }
`;

export const GET_CUSTOMER_PROJECTS = gql`
  query getCustomerProjects($input: CustomerProjects!) {
    getCustomerProjects(input: $input) {
      id
      customerId
      projectRefNumber
      status
      createdAt
      updatedAt
      customer {
        id
        firstName
        lastName
        email
        phone
      }
    }
  }
`;

export const GENERATE_INVOICE = gql`
  query previewInvoice($projectId: Int!, $source: String) {
    previewInvoice(projectId: $projectId, source: $source) {
      url
      additionalUrls
    }
  }
`;

export const LIST_PRODUCT_SYSTEMS = gql`
  query ListProductSystems {
    listProductSystems {
      id
      name
      thumbnail
      duration
      priority
      archived
      rank
    }
  }
`;

export const ANALYTICS_DASHBOARD = gql`
  query Analytics($input: analyticsDashboardInput!) {
    analyticsDashboard(input: $input) {
      totalProjects
      projectByProgress {
        label
        value
        color
      }
      completedProjects {
        total
        chart {
          labels
          datasets {
            label
            data
            backgroundColor
            borderWidth
            borderRadius
          }
        }
      }
      projectsByRep {
        reps {
          name
          count
        }
        chart {
          labels
          datasets {
            label
            data
            borderWidth
            borderRadius
            backgroundColor
          }
        }
      }
      revenues {
        labels
        label
        change
        sparkLine
        total
      }
      amountPaid {
        total
        percent
        chart {
          labels
          datasets {
            data
            backgroundColor
            borderWidth
          }
        }
      }
      leadsVsUsersVsRevenueChart {
        labels
        leadTotal
        activeUserTotal
        revenueTotal
        datasets {
          label
          data
          borderColor
          backgroundColor
          fill
          tension
          pointRadius
          borderWidth
          yAxisID
        }
      }
    }
  }
`;

export const GET_ALL_PERMISSION_TEMPLATES = gql`
  query GetAllPermissionTemplates($limit: Int!, $offset: Int!) {
    getAllPermissionTemplates(limit: $limit, offset: $offset) {
      templateName
      permissions {
        name
        permission
        subSections {
          name
          permission
        }
      }
    }
  }
`;

export const GET_SLACK_CHANNELS = gql`
  query channels {
    slackChannels
  }
`;

export const GET_WORKFLOWS = gql`
  query getWorkflows {
    getWorkflows {
      id
      eventType
      templateBody
      active
      recipients {
        id
        recipientId
        channel
        active
      }
    }
  }
`;

export const GET_SUPPLIERS = gql`
  query GetSuppliers($limit: Int!, $offSet: Int!) {
    supplierResponse(limit: $limit, offSet: $offSet) {
      id
      name
      email
      website
    }
  }
`;

export const LIST_FILES_FROM_S3: DocumentNode = gql`
  query ListFilesFromS3 {
    listFilesFromS3 {
      fileName
      Url
      lastModified
    }
  }
`;

export const GET_PROJECT_STAGES = gql`
  query GetProjectStages($projectId: Int!) {
    GetProjectStages(projectId: $projectId) {
      name
      completed
      completionPercentage
      subSections {
        name
        completed
        completionPercentage
        subSections {
          name
          completed
          completionPercentage
        }
      }
    }
  }
`;